// extracted by mini-css-extract-plugin
export default {"loader":"AreaLoader_loader__jKPxA","fade":"AreaLoader_fade__JiTcZ","text":"AreaLoader_text__x8roT","c2":"AreaLoader_c2__UDaEI"};